import React from 'react';
import dayjs from 'dayjs';
import { Avatar, Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';
import styles from './BusinessType.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t) => [

  {
    title: t('views.create_business_type.form.name'),
    width: '30%',
    dataIndex: 'full_name',
    fixed: 'left',
    align: 'left',
    render: (_, record) => (
      // eslint-disable-next-line react/jsx-filename-extension
      <div>
        <Avatar
          src={record?.logo_full_url}
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            marginRight: 10,
            background: '#eae4e4',
          }}
        />
        {` ${record.name} `}
      </div>
    ),
  },
  {
    width: '22.5%',
    title: t('tables.business_type.columns.description'),
    dataIndex: 'description',
    render: (description) => description || '-',
  },
  {
    width: '22.5%',
    title: t('tables.business_type.columns.type'),
    dataIndex: 'type',
    render: (type) => type || '-',
  },
  {
    width: '22.5%',
    title: t('tables.business_type.columns.devices_associated'),
    dataIndex: 'devices_associated',
    render: (devices_associated) => devices_associated || '-',
  },
  {
    width: '22.5%',
    title: t('tables.business_type.columns.communities_associated'),
    dataIndex: 'communities_associated',
    render: (communities_associated) => communities_associated || '-',
  },
];

const columnsDevices = (t, deleteBusinessType, currentUser, editBusinessType) => {

  const isAdmin = currentUser.role === 'Superadmin';

  const columns = commonColumns(t, deleteBusinessType, editBusinessType);

  if (isAdmin) {

    columns.push(
      {
        key: 'has_missing_data_alarm_rule',
        width: '20%',
        title: '',
        dataIndex: 'id',
        render: (_, record) => ( // edit users
          // eslint-disable-next-line react/jsx-filename-extension
          <Space>
            <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
              <FontAwesomeIcon icon={faPen} onClick={() => editBusinessType(record)} />
            </div>

            {(currentUser.id !== record.id) && (
              <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
                <Popconfirm
                  title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
                  okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
                  cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
                  onConfirm={() => deleteBusinessType(record)}
                  className="cursor-pointer"
                >
                  <FontAwesomeIcon icon={faTrash} title={t('views.dynamic_alarms.feedbacks.delete_alarms.not_delete_with_devices')} />
                </Popconfirm>
              </div>
            ) }
          </Space>
        ),
      },

    );

}

  return columns;

};

export default columnsDevices;
